import React, {PropTypes} from 'react';


function ProfileIcon(props) {
  const {
    className,
    ...otherProps
  } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" className={`profile-icon ${className}`} {...otherProps}>
        <path fill="#333" fillRule="evenodd" d="M14.839 7.437l-.259-.26a.934.934 0 0 1-.004-1.314.919.919 0 0 1 1.306-.004l1.846 1.848c.361.362.363.95.004 1.315l-1.847 1.87a.919.919 0 0 1-1.305.004.934.934 0 0 1-.004-1.315l.28-.285h-4.69a.93.93 0 1 1 0-1.86h4.673zm-7.454 9.296v2.058c0 .981-.965 1.528-1.798 1.01l-4.76-2.965C.34 16.533 0 15.916 0 15.342V1.39C0 1.094.088.836.235.636A.374.374 0 0 1 .289.541C.542.21.939 0 1.385 0h10.153a1.39 1.39 0 0 1 1.385 1.391v2.327c0 .514-.413.93-.923.93a.926.926 0 0 1-.923-.93V1.86l-6.913-.004 2.394 1.49c.486.303.827.921.827 1.495v10.033h3.692v-1.859c0-.513.413-.93.923-.93s.923.417.923.93v2.328c0 .77-.621 1.39-1.385 1.39H7.385zm-1.842-1.02V4.925L1.846 2.613V15.33l3.697 2.267v-1.703a.948.948 0 0 1 0-.182z"/>
    </svg>
  );
}


ProfileIcon.propTypes = {
  className: PropTypes.string
};

export default ProfileIcon;



// WEBPACK FOOTER //
// ./shared/common/svgs/ProfileIcon/index.js